"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KatalWebSellerCentralClient = exports.WeblabRegionType = exports.WeblabType = void 0;
/**
 * This will instruct the weblab api on how to use the MONs context
 */
var WeblabType;
(function (WeblabType) {
    /**
     * For use in a session based weblab
     */
    WeblabType["Session"] = "session";
    /**
     * Will use the customer id, should give consistent weblabs to all secondary sellers
     */
    WeblabType["Customer"] = "customer";
    /**
     * Weblabs will be at an individual merchant and users for the same Customer can have a different experience
     */
    WeblabType["Merchant"] = "merchant";
    /**
     * Weblabs will be at an individual user level
     */
    WeblabType["User"] = "user";
    /**
     * Weblabs will be based on partner accountId
     */
    WeblabType["Partner"] = "partner";
    /**
     * Weblabs will be at an individual vendor level
     */
    WeblabType["Vendor"] = "vendor";
})(WeblabType = exports.WeblabType || (exports.WeblabType = {}));
/**
 * Specifies which marketplace will be used for a weblab
 */
var WeblabRegionType;
(function (WeblabRegionType) {
    /**
     * This will use the Paris Host marketplace for any marketplace when calling the weblab service
     */
    WeblabRegionType["HostMarketplace"] = "host_marketplace";
    /**
     * Will use a predetermined set of marketplaces for the given region the site is in.
     * USAmazon -> USMarketplace
     * EUAmazon -> GBMarketplace
     * FEAmazon -> JPMarketplace
     * CNAmazon -> CNMarketplace
     */
    WeblabRegionType["Region"] = "region";
})(WeblabRegionType = exports.WeblabRegionType || (exports.WeblabRegionType = {}));
var KatalWebSellerCentralClient = /** @class */ (function () {
    function KatalWebSellerCentralClient(options) {
        var _a;
        this.options = options;
        this.weblabPath = '/mons/weblabs';
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.weblabPath) {
            this.weblabPath = this.options.weblabPath;
        }
    }
    /**
     * Setter method to set passed KatalMetrics publisher
     * @param publisher KatalMetrics publisher
     */
    KatalWebSellerCentralClient.prototype.setMetricsPublisher = function (publisher) {
        this.metricsPublisher = publisher;
    };
    /**
     * Method to call Mons weblab API to get treatments for the passed weblabs
     * It will make multiple API calls based on the weblab type
     * @param weblabs Array of weblabs
     * @returns Map of Weblab with its treatment
     */
    KatalWebSellerCentralClient.prototype.getTreatments = function (weblabs) {
        var _this = this;
        var sellerCentralWeblabs = weblabs;
        return this.verifySellerCentralWeblab(sellerCentralWeblabs).then(function () {
            var apiUrls = _this.getWeblabApiUrls(sellerCentralWeblabs);
            return _this.getTreatmentData(apiUrls).then(function (treatments) {
                // In case all API fails then throwing an error so the calling client can take care
                // of handling an exception
                if (!Object.keys(treatments).length) {
                    throw new Error('Unable to contact the Mons weblab service to retrieve weblab treatments.');
                }
                var treatmentMap = new Map();
                weblabs.forEach(function (weblab) {
                    var _a, _b;
                    // Using defaultTreatment in case API fails for that weblab
                    /**
                     * 08/17/23: When the API call to retrieve a Treatment fails, we fallback to the defaultTreatment and do not save the
                     * results in the cache (provided by KatalWeblab). If a treatment is "missing" (null), then that was an intentional, valid
                     * response from Weblab. To prevent a breaking change by respecting the valid `null` treatmentValue and altering the
                     * type returned from `getTreatment`, this behavior has been left alone, but the `assignmentMissing` flag will
                     * prevent `triggerWeblab` from triggering on this treatment.
                     */
                    var treatmentValue = ((_a = treatments[weblab.id]) === null || _a === void 0 ? void 0 : _a.treatment) || weblab.defaultTreatment;
                    var missingAssignment = !((_b = treatments[weblab.id]) === null || _b === void 0 ? void 0 : _b.treatment);
                    var treatment = _this.convertToTreatment(weblab, treatmentValue, missingAssignment);
                    treatmentMap.set(weblab, treatment);
                });
                return treatmentMap;
            });
        });
    };
    /**
     * Records a weblab trigger for the passed weblab
     * @param weblab Weblab to record the trigger
     * @param treatment Treatment to be recorded
     * @returns void
     */
    KatalWebSellerCentralClient.prototype.recordTrigger = function (weblab, treatment) {
        var _this = this;
        var sellerCentralWeblab = weblab;
        var apiData = this.getRecordTriggerApiData(sellerCentralWeblab, treatment);
        return this.verifySellerCentralWeblab([sellerCentralWeblab])
            .then(function () {
            return fetch(apiData.url, {
                method: 'post',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(apiData.body),
            });
        })
            .then(function (r) {
            _this.publishPerformanceTimerForUrl(r.url, 'RecordTrigger.Network');
            if (!r.ok) {
                throw new Error("Unable to contact the weblab service [".concat(apiData.url, "] to record weblab triggers. Status: ").concat(r.status, " Message: ").concat(r.statusText));
            }
        });
    };
    /**
     * Verify that all passed weblabs have weblabType and required data is present for new APIs
     * @param sellerCentralWeblabs Array of weblabs
     * @returns Resolved promise if it passes validation else rejected promise
     */
    KatalWebSellerCentralClient.prototype.verifySellerCentralWeblab = function (sellerCentralWeblabs) {
        var _this = this;
        var invalidWeblabs = sellerCentralWeblabs.filter(function (w) { return !w.weblabType || _this.isNotSupportedByNewApi(w); });
        if (!invalidWeblabs.length) {
            return Promise.resolve();
        }
        return Promise.reject(new Error('Invalid weblab type found or marketplaceId is missing. All weblabs must be of type SellerCentralWeblab or you must provide marketplaceId for partner account.'));
    };
    /**
     * Creates a query param format for old getTreatment API based on the weblab passed
     * @param weblab Weblab object
     * @returns Query param for the weblab API
     */
    KatalWebSellerCentralClient.prototype.convertWeblabToGetRequestFormat = function (weblab) {
        var marketplaceType = this.getWeblabMarketplaceType(weblab);
        var value = encodeURIComponent("".concat(weblab.id, ":").concat(weblab.weblabType, ":").concat(marketplaceType));
        return "weblab=".concat(value);
    };
    /**
     * Transforms a weblab & treatment value into required Response type
     * @param weblab Weblab
     * @param responseTreatment Treatment value
     * @param assignmentMissing Boolean to indicate whether responseTreatment has been overridden with the defaultTreatment
     * @returns Object of type Treatment with weblabId, treatment value & recordTrigger function
     */
    KatalWebSellerCentralClient.prototype.convertToTreatment = function (weblab, responseTreatment, assignmentMissing) {
        var _this = this;
        return {
            weblabId: weblab.id,
            treatmentValue: responseTreatment,
            assignmentMissing: !!assignmentMissing,
            recordTrigger: assignmentMissing
                ? function () { return Promise.resolve(); } // Don't record triggers when assignment missing.
                : function () { return _this.recordTrigger(weblab, responseTreatment); },
        };
    };
    /**
     * Generate a random id, used to uniquely identify a request when looking up
     * via the network performance timing api.
     * @return A random id.
     */
    KatalWebSellerCentralClient.prototype.randomId = function () {
        return Math.floor(Math.random() * 100000000);
    };
    /**
     * Pulls the request duration from the network performance timing api, if
     * available. Otherwise, undefined is returned. Note that the browser may
     * set the value of duration to 0 if it was not able to calculate it, so it
     * should be checked for truthiness before using.
     * @param url The url to get the precise timing value for.
     * @return The duration in millis a request to the given url took.
     */
    KatalWebSellerCentralClient.prototype.getRequestDuration = function (url) {
        if (performance === null || performance === void 0 ? void 0 : performance.getEntriesByName) {
            var entries = performance.getEntriesByName(url);
            if (entries === null || entries === void 0 ? void 0 : entries.length) {
                return entries[0].duration;
            }
        }
        return undefined;
    };
    /**
     * Attempts to get the duration of the request to the given url, and only
     * publishes it if the weblab proxy is configured with a metrics publisher,
     * and if the duration value was able to be found.
     * @param url The url to look up in the network performance api.
     * @param metric The metric name to send, if applicable.
     */
    KatalWebSellerCentralClient.prototype.publishPerformanceTimerForUrl = function (url, metric) {
        if (this.metricsPublisher) {
            var duration = this.getRequestDuration(url);
            if (duration) {
                this.metricsPublisher.publishTimerMonitor("".concat(metric, ".Latency"), duration);
            }
        }
    };
    /**
     * Generate array of URLs based on the weblabType for new API or use old API endpoint for few cases
     * @param weblabs Array of weblabs
     * @returns List of final URLs to be called to get weblab treatments
     */
    KatalWebSellerCentralClient.prototype.getWeblabApiUrls = function (weblabs) {
        var _this = this;
        var queryParamMapping = {};
        weblabs.forEach(function (weblab) {
            _this.updateUrlToQueryParamMapping(weblab, queryParamMapping);
        });
        return Object.keys(queryParamMapping).map(function (baseUrl) {
            return "".concat(baseUrl, "?").concat(queryParamMapping[baseUrl].join('&'), "&reqid=").concat(_this.randomId());
        });
    };
    /**
     * Updates the passed queryParamMapping object with query params segregated based on weblab/url type
     * Checks for fallback case which is not suppored by new API endpoints
     * @param weblab Weblab object
     * @param queryParamMapping Query param object which needs to be updated
     */
    KatalWebSellerCentralClient.prototype.updateUrlToQueryParamMapping = function (weblab, queryParamMapping) {
        if (this.doFallbackToOldApi(weblab)) {
            queryParamMapping[this.weblabPath] = (queryParamMapping[this.weblabPath] || []).concat(this.convertWeblabToGetRequestFormat(weblab));
        }
        else {
            var url = "/mons/weblabs/".concat(weblab.weblabType, "/treatment");
            queryParamMapping[url] = (queryParamMapping[url] || []).concat(this.convertWeblabToNewGetRequestFormat(weblab));
        }
    };
    /**
     * Checks for cases where we need to call old API endpoint.
     * New api needs marketplaceId passed from consumers for Session & Customer weblab type
     * when regionType is host_marketplace which is default we use
     * @param weblab Weblab object with all details
     * @returns Boolean value
     */
    KatalWebSellerCentralClient.prototype.doFallbackToOldApi = function (weblab) {
        // TODO - Need to update this method after full migration to the new API.
        // We can remove weblabType check and just keep weblabPath check as teams using custom path need to update their endpoint as well
        // or ask them to update their custom endpoint.
        // Clean up SIM - https://sim.amazon.com/issues/KAT-7760
        var _a;
        // In case weblabPath is provided by consumers then use that path with old query param logic
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.weblabPath) {
            return true;
        }
        return ((weblab.weblabType === WeblabType.Session ||
            weblab.weblabType === WeblabType.Customer) &&
            this.isMarketplaceIdRequiredAndNotPresent(weblab));
    };
    /**
     * MarketplaceId is required when regionType is not present or the value is host_marketplace
     * @param weblab Weblab object
     * @returns boolean value based on the above check
     */
    KatalWebSellerCentralClient.prototype.isMarketplaceIdRequiredAndNotPresent = function (weblab) {
        return (this.getWeblabMarketplaceType(weblab) ===
            WeblabRegionType.HostMarketplace && !weblab.marketplaceId);
    };
    /**
     * Creates a query param format for new getTreatment API based on the weblab passed
     * @param weblab Weblab object
     * @returns Query param for the weblab API
     */
    KatalWebSellerCentralClient.prototype.convertWeblabToNewGetRequestFormat = function (weblab) {
        var marketplaceType = this.getWeblabMarketplaceType(weblab);
        var value = encodeURIComponent("".concat(weblab.id, ":").concat(marketplaceType).concat(weblab.marketplaceId ? ":".concat(weblab.marketplaceId) : ''));
        return "weblab=".concat(value);
    };
    /**
     * Call Mons API for the passed urls. Handle API errors and merge treatment results into single object
     * @param apiUrls API Urls that needs to be called to get weblab treatments
     * @returns Treatment object, weblabId with its corresponding treatment value
     */
    KatalWebSellerCentralClient.prototype.getTreatmentData = function (apiUrls) {
        return __awaiter(this, void 0, void 0, function () {
            var apiResponses, treatments;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.allSettled(apiUrls.map(function (url) {
                            return fetch(url).then(function (res) {
                                _this.publishPerformanceTimerForUrl(res.url, 'GetTreatments.Network');
                                return res.json();
                            });
                        }))];
                    case 1:
                        apiResponses = _a.sent();
                        treatments = {};
                        apiResponses.forEach(function (response) {
                            if (response.status === 'fulfilled') {
                                if (response.value.treatments) {
                                    Object.assign(treatments, response.value.treatments);
                                }
                                else {
                                    // API failed with 4xx or 5xx
                                    _this.publishCountMetric("".concat(response.value.path, ".Error"));
                                }
                            }
                            else {
                                // Fetch call is rejected due to any network issues
                                _this.publishCountMetric('ApiNetworkError');
                            }
                        });
                        return [2 /*return*/, treatments];
                }
            });
        });
    };
    /**
     * Publish count metric with monitor if metricsPublisher is defined
     * @param metric Metric key
     */
    KatalWebSellerCentralClient.prototype.publishCountMetric = function (metric) {
        if (this.metricsPublisher) {
            this.metricsPublisher.publishCounterMonitor(metric, 1);
        }
    };
    /**
     * Creates url & body for the recordTrigger request. Fallback to old api if required data is not present.
     * @param weblab Weblab object
     * @param treatment Treatment value
     * @returns Object with url & body for new api or just url for the old api
     */
    KatalWebSellerCentralClient.prototype.getRecordTriggerApiData = function (weblab, treatment) {
        var marketplaceType = this.getWeblabMarketplaceType(weblab);
        if (this.doFallbackToOldApi(weblab)) {
            return {
                url: "".concat(this.weblabPath, "/").concat(weblab.id, "/trigger/").concat(treatment, "?weblabType=").concat(weblab.weblabType, "&marketplaceType=").concat(marketplaceType, "&reqid=").concat(this.randomId()),
            };
        }
        return {
            url: "/mons/weblabs/".concat(weblab.weblabType, "/trigger?reqid=").concat(this.randomId()),
            body: {
                weblabId: weblab.id,
                treatmentId: treatment,
                marketplaceType: marketplaceType,
                marketplaceId: weblab.marketplaceId || null,
            },
        };
    };
    /**
     * Returns weblab regionType if present else fallback host_marketplace
     * @param weblab Weblab object
     * @returns Marketplace type
     */
    KatalWebSellerCentralClient.prototype.getWeblabMarketplaceType = function (weblab) {
        return weblab.regionType || WeblabRegionType.HostMarketplace;
    };
    /**
     * Verify if data provided by consumers is supported by new API or not.
     * If the weblabType is of specific types and marketplaceType is host_marketplace
     * then marketplaceId is required
     * @param weblab Weblab object
     * @returns Boolean value
     */
    KatalWebSellerCentralClient.prototype.isNotSupportedByNewApi = function (weblab) {
        // TODO - Need to update this array after full migration to the new API.
        // 'WeblabType.Customer' & 'WeblabType.Session' should be included in the list as Mons doesn't have fallback.
        // Clean up SIM - https://sim.amazon.com/issues/KAT-7760
        var weblabTypesToCheck = [WeblabType.Partner];
        return (weblabTypesToCheck.includes(weblab.weblabType) &&
            this.isMarketplaceIdRequiredAndNotPresent(weblab));
    };
    return KatalWebSellerCentralClient;
}());
exports.KatalWebSellerCentralClient = KatalWebSellerCentralClient;
